<template>
    <main>
        <div class="main-container">
            <div class="main-content">
                <PartyView />
            </div>
        </div>
    </main>
</template>

<script>
import PartyView from '@/views/party/Index.vue';

export default {
    name: 'PartyTemplate',

    components: {
        PartyView,
    },
};
</script>
